<template></template>
<template>
  <div id="pb-report">
    <div></div>
    <el-scrollbar :class="isCollapse ? 'menu_hide rightSide' : 'rightSide'">
      <el-main>
        <nav-bar></nav-bar>
        <!--        <el-breadcrumb separator-class="el-icon-arrow-right" class="mainBread">-->
        <!--          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>-->
        <!--          <el-breadcrumb-item :to="{ path: '/' }">报表服务</el-breadcrumb-item>-->
        <!--          <el-breadcrumb-item>峰平谷电量统计</el-breadcrumb-item>-->
        <!--        </el-breadcrumb>-->
        <div>
          <el-card v-loading="loading" style="">
            <div id="container" style="width: 100%; height: 1024px"></div>
          </el-card>
        </div>
      </el-main>
    </el-scrollbar>
  </div>
</template>

<script>
import * as pbi from "powerbi-client";
import $ from "jquery";
import { getEmbedInfo } from "@/api/api";
import { mapState } from "vuex";
import { getItemFormLocalstorage } from "../../../utils/package-localstorage";
import { getMyMenuObj } from "../../utils/util";

const powerbi = new pbi.service.Service(
  pbi.factories.hpmFactory,
  pbi.factories.wpmpFactory,
  pbi.factories.routerFactory
);
let report = null;
let timerobj;
export default {
  name: "pb_report",
  data() {
    return {
      loading: true,
      loadingstyle: {
        padding: "0px",
        opacity: 0.5,
      },
    };
  },
  props: {
    msg: String,
  },
  mounted() {
    let _this = this;
    $("#container").height(window.innerHeight - 115);
    this.TryBindPBI();
  },
  methods: {
    refreshData() {
      if (report) report.refresh();
    },
    timer() {
      timerobj= setInterval(() => {
        this.refreshData();
        console.log("refleshed");
      }, 30000);
    },
    TryBindPBI() {
      var that = this;
      setTimeout(() => {
        //检查是否已取到菜单
        if (getItemFormLocalstorage("menuData")) {
          that.BindPBI();
        } else {
          that.TryBindPBI();
        }
      }, 100);
    },
    BindPBI() {
      var curMenu = getMyMenuObj();
      var groupid = "";
      var reportid = "";
      var pageid = "";
      if (curMenu.pbiUrl) {
        var dataStr = curMenu.pbiUrl;
        if (curMenu.pbiUrl.indexOf("groups/") >= 0) {
          dataStr = curMenu.pbiUrl
            .substring(curMenu.pbiUrl.indexOf("groups/"))
            .replace("groups/", "")
            .replace("/reports/", ".");
        }
        if (dataStr.split(".").length >= 0) groupid = dataStr.split(".")[0];
        if (dataStr.split(".").length >= 1) reportid = dataStr.split(".")[1];
        if (dataStr.split(".").length >= 2) pageid = dataStr.split(".")[2];
      }

      var data = {
        groupId: groupid,
        reportId: reportid,
        pageId: pageid,
      };

      getEmbedInfo(data).then((res) => {
        var that = this;
        if (res.success) {
          const embedData = res.result;
          if (!embedData.embedUrl) {
            if(embedData.message==$t('NoAccessTokenFound')) that.$message.error("You have no permission to view this report.");
            else that.$message.error(embedData.message + "please try login again.");
            that.loading = false;
            return;
          }
          var reportConfig = {
            type: "report",
            tokenType: pbi.models.TokenType.Embed, //pbi.models.TokenType.Embed,Aad
            accessToken: embedData.accessToken,
            embedUrl: embedData.embedUrl,
            id: reportid,
            permissions: pbi.models.Permissions.All,
            /*
          // Enable this setting to remove gray shoulders from embedded report
          settings: {
              background: models.BackgroundType.Transparent
          }
          */
            settings: {
              panes: {
                filters: {
                  visible: true,
                },
                pageNavigation: {
                  visible: false,
                },
              },
              // filterPaneEnabled: false,
              // navContentPaneEnabled: true,
            },
          };
          // Use the token expiry to regenerate Embed token for seamless end user experience
          // Refer https://aka.ms/RefreshEmbedToken
          // const tokenExpiry = embedData.embedTokenExpiry

          // Get a reference to the embedded report HTML element
          var embedContainer = document.getElementById("container");

          // Embed Power BI report
          report = powerbi.embed(embedContainer, reportConfig);

          //     report2 = powerbi.get(embedContainer);
          // report
          //   .setPage("ReportSection1d9d94114b86d9251812")
          //   .then(function () {
          //     console.log("Page was set to: ReportSection1d9d94114b86d9251812");
          //   })
          //   .catch(function (errors) {
          //     console.log(errors);
          //   });

          // report.getFilters().then((filters) => {
          //   console.log(filters);
          // });

          // Clear any other loaded handler events
          report.off("loaded");

          // Triggers when a report schema is successfully loaded
          report.on("loaded", function () {
            // embedContainer.show()
            const basicFilter = {
              $schema: "http://powerbi.com/product/schema#basic",
              target: {
                table: "DimProductSubcategory",
                column: "EnglishProductSubcategoryName",
              },
              operator: "In",
              values: ["Cranksets", "Wheels"],
              filterType: 1, // pbi.models.FilterType.BasicFilter
              // requireSingleSelection: true // Limits selection of values to one.
              displaySettings: {
                isLockedInViewMode: true,
                displayName: "Number of stores",
              },
            };
            report.setFilters([basicFilter]).catch((errors) => {
              // Handle error
            });
            if (pageid) {
              report
                .setPage(pageid)
                .then(function () {

                })
                .catch(function (errors) {

                });
            }

            that.loading = false;
          });

          // Clear any other rendered handler events
          report.off("rendered");

          // Triggers when a report is successfully embedded in UI
          report.on("rendered", function () {
          });

          // Clear any other error handler event
          report.off("error");

          // Below patch of code is for handling errors that occur during embedding
          report.on("error", function (event) {
            const errorMsg = event.detail;

            // Use errorMsg variable to log error in any destination of choice
            console.error(errorMsg);
          });

          that.timer();
        }
      },(err) => {
            that.$message.error(err.error.message);
          }).catch((err)=>{
that.$message.error("Load report failed");

          });
    },
  },
  computed: mapState({
    isCollapse: (state) => state.isCollapse,
  }),
  destroyed() {
    clearTimeout(timerobj);
  },
};
</script>
<style scope>
.el-card__body {
  padding: 0px;
}
</style>
